

export function searchDate(date, input){
    return input && date.format("DD-MM-YYYY") &&  date.format("DD-MM-YYYY").includes(input)
}